<div class="text-center mt-3 pt-3 scroll-x">
  @if (total > 0) {
    <ngb-pagination
      [collectionSize]="collectionSize"
      [page]="page"
      [maxSize]="4"
      [boundaryLinks]="true"
      class="d-inline-block"
      (pageChange)="setPage($event)">
      <ng-template ngbPaginationFirst><span class="material-symbols-outlined">first_page</span></ng-template>
      <ng-template ngbPaginationPrevious><span class="material-symbols-outlined">chevron_left</span></ng-template>
      <ng-template ngbPaginationNext><span class="material-symbols-outlined">chevron_right</span></ng-template>
      <ng-template ngbPaginationLast><span class="material-symbols-outlined">last_page</span></ng-template>
    </ngb-pagination>
  }
</div>
